import {AfterViewChecked, AfterViewInit, Component, Input, OnDestroy, OnInit, Output} from '@angular/core';
import * as moment from 'moment';
import {Program} from '@models/program';
import {Class} from '@models/class';
import {Schedule} from '@models/schedule';
import {Subject} from 'rxjs';
import {BehaviorSubject} from 'rxjs/internal/BehaviorSubject';
import {ProgramScheduleComponent} from '@pages/layout/program/program-page/program-schedule/program-schedule.component';
import {ViewCurriculumComponent} from '@pages/layout/program/program-page/program-curriculum/view-curriculum/view-curriculum.component';
import {MatDialog} from '@node_modules/@angular/material';

@Component({
  selector: 'app-program-schedule-week',
  templateUrl: './program-schedule-week.component.html',
  styleUrls: ['./program-schedule-week.component.scss']
})
export class ProgramScheduleWeekComponent implements OnInit, OnDestroy, AfterViewChecked {
  @Input() source = 'schedule';
  @Input() isAdmin = true;
  @Input() withData = false;
  @Input() programSubject: BehaviorSubject<Program>;
  @Input() programs: Program[];
  @Input() onToday: Subject<any>;
  @Input() onLeft: Subject<any>;
  @Input() onRight: Subject<any>;
  @Input() onClosePopupClass: BehaviorSubject<boolean>;
  @Output() currentClass: Subject<Class> = new BehaviorSubject(null);

  popupOpen = false;
  program: Program;
  currentClassLocal: Class;
  currentMonth = moment();
  currentYear = moment();
  startOfWeek = moment().startOf('isoWeek');
  endOfWeek = moment().endOf('isoWeek');
  week = [];
  timeRange: {
    min: string,
    max: string,
  } = { min: '', max: ''};
  durations;
  classesByDates = {};
  classesByDates2 = {};
  viewCirriculumDialog;
  defaultFormat = 'MMM Do YY HH:mm A';
  subscribes = [];
  monthNames = [
    'January', 'February', 'March',
    'April', 'May', 'June',
    'July', 'August', 'September',
    'October', 'November', 'December'
  ];

  constructor(
      public dialog: MatDialog,
  ) {}

  ngOnInit() {
    this.subscribes.push(this.programSubject.subscribe(
      resp => {
        const schedules = [];
        resp.classes.map( cl => {
          schedules.push(...cl.schedule);
        });
        resp.schedule = schedules;
        this.program = resp;
        this.getWeek();
        this.getTimeCurriculums();
        if (this.timeRange.max && this.timeRange.min) {
          this.durations = new Array(Math.round(moment.duration(moment(this.timeRange.max, 'HH:mm A').diff((moment(this.timeRange.min, 'HH:mm A')))).asHours() + 1));
        } else {
          this.durations = 0;
        }
        this.updateClassesByDate();
        // ProgramScheduleComponent.findInitLessonNumber(Object.assign({}, resp), this.currentMonth);
      }
    ));
    if (this.source !== 'overview' || this.withData === true) {
      this.subscribes.push(this.onToday.subscribe(
        (resp: any) => {
          if (resp) {
            this.startOfWeek = moment().startOf('isoWeek');
            this.endOfWeek = moment().endOf('isoWeek');
            this.getWeek();
            this.updateClassesByDate();
          }
        }
      ));
      this.subscribes.push(this.onLeft.subscribe(
        (resp: any) => {
          if (resp && resp === 'week') {
            // if (resp === 'month') {
            //   this.startOfWeek = this.startOfWeek.add(-1, 'month');
            //   this.endOfWeek = this.endOfWeek.add(-1, 'month');
            // }
            this.startOfWeek = this.startOfWeek.add(-7, 'days');
            this.currentYear = this.startOfWeek.clone();
            this.endOfWeek = this.endOfWeek.add(-7, 'days');
            this.getWeek();
            this.updateClassesByDate();
          }
        }
      ));
      this.subscribes.push(this.onRight.subscribe(
        (resp: any) => {
          if (resp && resp === 'week') {
            // if (resp === 'month') {
            //   this.startOfWeek = this.startOfWeek.add(1, 'month');
            //   this.endOfWeek = this.endOfWeek.add(1, 'month');
            // }
            this.startOfWeek = this.startOfWeek.add(7, 'days');
            this.currentYear = this.startOfWeek.clone();
            this.endOfWeek = this.endOfWeek.add(7, 'days');
            this.getWeek();
            this.updateClassesByDate();
          }
        }
      ));
      const programSChedule = document.getElementsByClassName('program-schedule').item(0);
      if (programSChedule) {
        programSChedule.addEventListener('click', (event) => {
          this.disableAllClasses();
        });
      }
      this.onToday.next(true);
    }
    if (this.onClosePopupClass) {
      this.onClosePopupClass.subscribe(
        resp => {
          if (resp === true) {
            this.currentClassLocal = null;
          }
        }
      );
    }
  }
  ngAfterViewChecked() {
    // this.boardIsReady = true;
  }

  currentDay(weekDay) {
    const date = new Date();
    date.setHours(0, 0, 0, 0);
    if (date.toString() === weekDay.toString()) {
      return 'active';
    } else {
      return '';
    }
  }

  getWeek() {
    this.week = [];
    let day = this.startOfWeek;
    this.currentMonth = day;
    while (day <= this.endOfWeek) {
      this.week.push(day.toDate());
      day = day.clone().add(1, 'd');
        if (day.format('ll') === moment().format('ll')) {
            this.currentMonth = day;
        }
    }
  }

  getDayNumber(day) {
    return moment(day).date();
  }

  getDayName(day) {
    return moment(day).format('dddd').slice(0, 3).toLowerCase();
  }
  getStoredClassByDate(day, i) {
    const time = moment(this.timeRange.min, 'HH:mm A').add(i, 'hours');
    let classc = [];
    const dayMoment = moment(day);
    const date = dayMoment.hour(time.hour()).minute(time.minute()).format('MMM Do YY');
    const timeAction = moment(day).hour(time.hour()).minute(time.minute()).format(this.defaultFormat);
    if (this.classesByDates[date] && this.classesByDates[date][dayMoment.date()]) {
      for (const i in this.classesByDates[date][dayMoment.date()]) {
        if (this.classesByDates[date][dayMoment.date()][i][timeAction]) {
          classc = classc.concat(this.classesByDates[date][dayMoment.date()][i][timeAction]);
        }
      }
    }
    return classc ? classc : [];
  }
  getTimeClass(i) {
    let time;
    if (this.source === 'overview') {
      // time = moment(this.timeRange.min, 'HH:mm A').add(i, 'hours').format('hh A');
      time = moment(this.timeRange.min, 'HH:mm A').add(i, 'hours').format('LT');
    } else {
      time = moment(this.timeRange.min, 'HH:mm A').add(i, 'hours').format('LT');
    }
    return time;
  }
  getTimeCurriculums() {
    let schedulesSorted = [];
    if (this.source === 'overview') {
      schedulesSorted = this.program.schedule;
    } else {
      schedulesSorted = [].concat(...this.programs.map(progr => progr.schedule));
    }
    schedulesSorted.sort((a: Schedule, b: Schedule) => {
      const beginningTime = moment(a.start, 'HH:mm A');
      const endTime = moment(b.start, 'HH:mm A');
      return +beginningTime.isAfter(endTime) > 0 ? 1 : -1;
    });
    if (schedulesSorted[0] && schedulesSorted[0].start && schedulesSorted[0].end) {
      this.timeRange.min = moment(schedulesSorted[0].start, 'HH:mm A').startOf('hour').format('HH:mm A');
      schedulesSorted.sort((a: Schedule, b: Schedule) => {
        const beginningTime = moment(a.end, 'HH:mm A');
        const endTime = moment(b.end, 'HH:mm A');
        return +beginningTime.isBefore(endTime) > 0 ? 1 : -1;
      });
      const timeEmd = moment(schedulesSorted[0].end, 'HH:mm A');
      if (timeEmd.hour() !== 23) {
        timeEmd.add(1, 'hours');
      }
      this.timeRange.max = timeEmd.startOf('hour').format('HH:mm A');
    }
  }
  getClassByDate(day, i) {
    const time = moment(this.timeRange.min, 'HH:mm A').add(i, 'hours');
    const programs = this.source === 'overview' ? [this.program] : this.programs;
    this.classesByDates = ProgramScheduleComponent.getClassByDate(this.program, programs, day, this.classesByDates, true, time);
  }
  showClass(event, classc: Class, y, day) {
    if (!this.isProgramsClass(classc) || this.source === 'overview') {
      return false;
    }
    let target = event.target;
    if (!target.classList.contains('program-schedule-content-cell-class-inner')) {
      target = event.target.closest('.program-schedule-content-cell-class-inner');
    }
    if (target) {
      event.preventDefault();
      event.stopPropagation();
      this.disableAllClasses(target);
      // this.currentClass.next(null);
      this.popupOpen = true;
      this.currentClassLocal = Object.assign({}, classc);
      // console.log(this.currentClassLocal);
      this.currentClassLocal.cssClass = classc.cssClass + y;
      const block = document.getElementById(classc.cssClass + y); {
        if (block) {
          block.classList.add('selected_class');
        }
      }
      const popup = target.getElementsByClassName('popup-with-class-hidden').item(0);
      if (popup) {
        popup.style.display = 'block';
        let rectangle = popup.getBoundingClientRect() as { x: number, y: number };
        if (+(document.documentElement.offsetWidth / rectangle.x).toFixed(2) < 1.7) {
          popup.style.left = '-440px';
          this.currentClassLocal.cssClass = 'triangle-to-right';
          rectangle = popup.getBoundingClientRect() as { x: number, y: number };
        } else {
          this.currentClassLocal.cssClass = 'triangle-to-left';
          rectangle = popup.getBoundingClientRect() as { x: number, y: number };
        }
        this.currentClassLocal.styles = {
          top: (rectangle.y - 50) + 'px',
          left: (rectangle.x) + 'px',
        };
        this.currentClassLocal.selectedDay = day;
        // console.log(classc);
        this.currentClass.next(this.currentClassLocal);
        console.log(this.currentClassLocal);
        popup.style.left = '';
        if (this.currentClassLocal && classc && this.currentClassLocal.selectedSchedule[0] &&
          classc.selectedSchedule[0] &&
          this.currentClassLocal.selectedSchedule[0].id === classc.selectedSchedule[0].id) {
          this.currentClassLocal = null;
        }
      }
    }
  }
  updateClassesByDate() {
    this.classesByDates = [];
    for (let i = 0; i < this.durations.length; i++) {
      this.week.map( (day, y) => {
        this.getClassByDate(day, i);
      });
    }
  }
  disableAllClasses(target = null) {
    this.currentClass.next(null);
    if (!target) {
      const classes = document.getElementsByClassName('program-schedule-content-cell-class-inner');
      Object.keys(classes).forEach( item => {
        if (item) {
          classes[item].classList.remove('selected_class');
        }
      });
    } else {
      const parent = target.closest('.program-schedule-content-week');
      if (parent) {
        const classes = parent.getElementsByClassName('program-schedule-content-cell-class-inner');
        Object.keys(classes).forEach(item => {
          if (item) {
            classes[item].classList.remove('selected_class');
          }
        });
      }
    }
    return false;
  }
  isProgramsClass(classc: Class) {
    let finded = false;
    this.program.classes.map( item => {
      if (item.id === classc.id) {
        finded = true;
      }
    });
    return finded;
  }
  ngOnDestroy() {
    this.subscribes.map( subscr => {
      subscr.unsubscribe();
    });
  }
  onOpenViewCurriculumModal(classc) {
      let curriculum;
      const curriculums = [];
      this.program.curriculum.map( curr => {
          curr.lessons.map( item => {
              if (item.id === classc.lesson.id) {
                  curriculum = curr;
              }
          });
      });
      if (curriculum) {
          this.programs.map( item => {
              item.curriculum.map( curr => {
                  if (curr.id !== curriculum.id) {
                      curriculums.push(curr);
                  }
              });
          });
          ViewCurriculumComponent.source = 'student';
          ViewCurriculumComponent.onlyLesson = true;
          ViewCurriculumComponent.curriculum = curriculum;
          ViewCurriculumComponent.program = this.program;
          ViewCurriculumComponent.initClass = classc;
          ViewCurriculumComponent.initLesson = classc.lesson;
          ViewCurriculumComponent.fullContent = false;
          ViewCurriculumComponent.onlyDescription = false;
          this.viewCirriculumDialog = this.dialog.open(ViewCurriculumComponent, {
              panelClass: 'mkc-dashboard-lesson-dialog',
              backdropClass: 'mkc-dashboard-lesson-backdrop'
          });
          ViewCurriculumComponent.modalRef = this.viewCirriculumDialog;
          this.viewCirriculumDialog.afterClosed().subscribe(result => {
              this.viewCirriculumDialog.close();
          });
      }
  }
}
